import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'duration'
})
export class DurationPipe implements PipeTransform {

    transform(milliseconds: number): string {
        if (milliseconds < 1000) {
            return `${milliseconds} ms`;
        }
        const seconds = (milliseconds / 1000).toFixed(1);
        return `${seconds} s`;
    }
}
